export enum ConditionOperator {
  IsBlank,
  NotBlank,
  Equal,
  NotEqual,
  Contains,
  NotContains,
  GreaterThan,
  LessThan,
}